import styled from 'styled-components';

export const ProgramH2 = styled.h2`
  color: rgb(112, 56, 149);
  font-family: 'Bree Serif', Merriweather, Georgia, serif;
  font-size: 18px;
  font-weight: 700;
`;
